import React, {Component, ReactElement} from 'react'
import NatTokenRepo from '../token/repository/NatTokenRepo'
import {NatGetToken} from '../token/repository/NatGetToken'
import NatResidentUserRepo from '../residentUser/repository/NatResidentUserRepo'
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    MainContainer,
    ParagraphText,
} from '../../../styledComponents/ContentsArea'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {DisplayBlockDiv} from '../../../styledComponents/DisplayItem'
import {PrimaryStyledButton} from '../../../styledComponents/Button'
import {getQueryParameter, NatAsyncCallFunction} from '../../common/util/Natutil'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Nullable} from '../../../app/TypeHelpers'
import {Messages} from '../../../Messages'
import {Location} from 'react-router-dom'

interface Props {
    tokenRepo: NatTokenRepo,
    residentUserRepo: NatResidentUserRepo,
    location: Location,
}

interface States {
    token: NatGetToken
    isLoadCompleted: boolean
}

class NatResidentChangeMailAddressCompletePage extends Component<Props & ResidentPagePropsSet, States> {
    queryToken: string

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            token: {
                details: {
                    token: '',
                    sutekiNetId: '',
                    mailAddress: '',
                    authenticationKey: '',
                    parentResidentId: '',
                    policyAgreeType: '',
                    referenceId: '',
                    condominiumCd: '',
                    condominiumName: '',
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    familyName: '',
                    firstName: '',
                    familyNameKana: '',
                    firstNameKana: '',
                    freeSettingItem: '',
                    flpExistFlag: '',
                },
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            isLoadCompleted: false,
        }
        this.queryToken = getQueryParameter('token', this.props.location.search)
        this.backLoginButtonClick = this.backLoginButtonClick.bind(this)
    }

    async componentDidMount(): Promise<void> {

        try {
            // トークン取得
            if (!this.queryToken) {
                this.props.navigate('/resident/error', {state: {message: Messages.ERESR0008.toString()}})
            } else {
                await this.props.eventEmitter.showLoading()
                const retToken: Nullable<NatGetToken> = await NatAsyncCallFunction(
                    this.props.tokenRepo.getToken.bind(
                        this.props.tokenRepo,
                        this.queryToken), this.props.navigate)

                if (retToken && retToken.details === null) {
                    this.props.navigate('/resident/error', {state: {message: Messages.ERESR0008.toString()}})
                } else {
                    // 居住者ユーザ更新(トークン)
                    await NatAsyncCallFunction(
                        this.props.residentUserRepo.updateResidentUserToken.bind(
                            this.props.residentUserRepo, {token: this.queryToken}), this.props.navigate)
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    // ログインページへ
    backLoginButtonClick(): void {
        this.props.navigate(
            `/resident/login`,
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        メールアドレスの変更確認
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <MainContainer>
                    <MessageBlock>
                        <Message>
                            メールアドレスの変更を完了いたしました。
                        </Message>
                    </MessageBlock>
                    <DisplayBlockDiv>
                        <PrimaryStyledButton
                            onClick={this.backLoginButtonClick}>
                            ログインページへ
                        </PrimaryStyledButton>
                    </DisplayBlockDiv>
                </MainContainer>
            </>
        )
    }
}

export default createResidentPage(NatResidentChangeMailAddressCompletePage)

// メッセージブロック
const MessageBlock: StyledDiv = styled.div`
  text-align: center;
`
// メッセージ
const Message = styled(ParagraphText)`
  display: inline-block;
  text-align: left;
`
